export class OrganisationTokenUnavailableError extends Error {
  constructor() {
    super("OrganisationTokenUnavailable");
  }
}
